// 英文语言包
export default {
  nav: {
    home: 'VESCOR Homepage',
    brand: 'Brand',
    product: 'Products',
    exclusive: 'Luxury Skincare Experience Program',
    cooperation: 'Partnership',
    contact: 'Contact Us',
    bMenu: {
      understand: 'About VESCOR',
      tech: 'Technology & Expertise',
      desc1: 'Amid the snow-capped folds of the Alps, scientists at Switzerland’s Cellcare Laboratory drew inspiration from glacial meltwater to decode time’s whispers to the skin. Founded in 2017, VESCOR is not only a high-end skincare brand but also an aesthetic pact that transcends time and space.',
      desc2: 'Cellcare Switzerland Laboratory, together with CRB—one of the world’s top three eco-pure raw material research and production centers—has pioneered revolutionary skincare technology.'
    },
    pMenu: {
      allProducts: 'All Products',
      mask: 'Masks',
      elastic: 'Elastic Revitalizing Series',
      essence: 'Essence Series',
      mask1: 'Collagen Secert Skin Mask',
      mask2: 'Mask Black Diamond Charcoal Facial Mask',
      elastic1: 'Resilience Revitalizing Essence Water',
      elastic2: 'Resilience Revitalizing Anti-wrinkle Serum',
      elastic3: 'Resilience Revitalizing Anti-wrinkle Cream',
      essence1: 'Rejuvenating Extract Essence Oil',
      essence2: 'Soft And Moist Liquid Foundation'
    },
  },
  footer: {
    copyright: '- VESCOR © 2025 -'
  },
  home: {
    story: {
      title1: 'Originated from the Natural Wonders of the Alps',
      title2: 'A Dialogue Between Nature and Time',
      desc1: 'In the tranquil valleys of Zurich, Switzerland, ancient glaciers have flowed for millennia, bearing witness to the strength of nature and the artistry of time. It is on this land—where life itself is shaped—that the Cellcare Swiss Laboratory was founded, at the intersection of science and nature.',
      desc2: 'In 2017, the laboratory gave birth to VESCOR—',
      desc3: 'a premium skincare brand devoted to decoding the secrets of youthful skin, unveiling a new chapter of timeless beauty for modern women in pursuit of excellence.',
      more: 'Know More About VESCOR STORY...'
    },
    tech: {
      title1: 'Technology & Expertise',
      title2: 'Swiss Scientific Assurance',
      desc1: 'Backed by Swissmedic certification and compliant with EU GMP standards, Cellcare Swiss Laboratory unites scientific precision with artisanal craftsmanship.',
      desc2: 'With meticulously selected Alpine thermal spring water and organic European ingredients, and in collaboration with the Mibelle Group and CRB Laboratories, Cellcare has pioneered revolutionary skincare technology. Through advanced Gene Anti-Glycation Technology, it precisely combats glycation, restoring skin’s elasticity and radiance—defining the essence of Swiss luxury skincare aesthetics.',
      more: 'Know More About VESCOR STORY...'
    },
    features: {
      feature1: {
        title: 'Gene Anti-Glycation Technology',
        desc: 'Targets and repairs glycation sites, prevents collagen aging, and restores skin’s elasticity and youthful radiance.'
      },
      feature2: {
        title: 'Plant Nano-Extracts',
        desc: 'Ultra-micro molecules penetrate deep into the skin for instant absorption, delivering refreshing hydration.'
      },
      feature3: {
        title: 'High-Efficiency, Weightless Skincare Philosophy',
        desc: 'Streamlined and precise—visible results upon application. Skincare and repair return to a natural yet highly effective approach, achieving true scientific beauty.'
      }
    },
    product: {
      title1: '"Beauty belongs not only to the skin—but to a life of elegance"',
      title2: 'Schönheit gehört nicht nur zur Haut, sondern auch zum eleganten',
      title3: 'This is the unwavering belief that defines VESCOR.',
      philosophy1: '"Beauty Awakens · Time Fears Not"',
      philosophy2: 'Which is VESCOR’s enduring philosophy.',
      philosophyDesc1: 'In the busyness of modern urban life, VESCOR is more than skincare—it is a lifestyle:',
      philosophyDesc2: 'Balanced. Composed. Graceful.',
      philosophyDesc3: 'In every moment of beauty awakening,',
      philosophyDesc4: 'Unlock the eternal key to being “fearless time”.',
      more: 'Know More About VESCOR STORY...',
      productMore: 'Learn more...',
      descriptions: {
        product1: 'Resilience Revitalizing Essence Water',
        product1Desc: '“VESCOR Magic 1+1” — the first step in antioxidant defense, launching the battle against glycation.',
        product2: 'Resilience Revitalizing Anti-wrinkle Serum',
        product2Desc: '“VESCOR Magic 1+1” — deeply penetrates to activate elasticity, with dual antioxidant and anti-glycation effects.',
        product3: 'Resilience Revitalizing Anti-wrinkle Cream',
        product3Desc: '“VESCOR Magic 1+1” — locks in a naturally flawless look, providing long-lasting hydration and protective freshness.',
        product4: 'COLLAGEN SECRET SKIN MASK',
        product4Desc: 'Rich in collagen, the secret to maintaining youthful skin.',
        product5: 'BLACK DIAMOND CHARCOAL FACIAL MASK',
        product5Desc: 'Enhanced with Binchotan charcoal, it quenches your skin’s thirst for hydration.',
        product6: 'Rejuvenating Extract Essence Oil',
        product6Desc: 'Squalane nourishes the skin with oil, unlocking the secret to age-defying skin.',
        product7: 'Soft And Moist Liquid Foundation',
        product7Desc: 'The magical power of Camellia Seed Oil—effortlessly creating a naturally flawless base.',
      }
    },

  },
  join: {
    title1: 'Join',
    title2: 'VESCOR is dedicated to creating for modern women who are both inner and outer',
    title3: 'Luxury Care Experience Plan',
    desc1: 'Together, we pursue the harmony of nature and science, care deeply for the skin’s inner and outer well-being, and explore our true selves—undaunted by the passage of time.',
    desc2: 'Whether meeting challenges with confidence in the workplace, or embracing stillness in everyday life, VESCOR walks alongside her—empowering beauty with calm.',
    more: 'Find more details...'
  },
  brand: {
    title1: 'Originated from the Natural Wonders of the Alps',
    subtitle1: 'A Dialogue Between Nature and Time',
    subtitle2: '"Beauty Awakens · Time Fears Not"',
    subtitle3: 'Which is VESCOR’s enduring philosophy.',
    subtitle4: 'VESCOR Luxury Skincare Experience Program',
    subtitle5: 'Exclusively crafted for the modern woman who seeks balance inside and out.',
    content1: 'A Dialogue Between Nature and Time<br />In the tranquil valleys of Zurich, Switzerland, ancient glaciers have flowed for millennia, bearing witness to the strength of nature and the artistry of time.<br />It is on this land—where life itself is shaped—that the Cellcare Swiss Laboratory was founded, at the intersection of science and nature.<br />In 2017, the laboratory gave birth to VESCOR—<br />a premium skincare brand devoted to decoding the secrets of youthful skin, unveiling a new chapter of timeless beauty for modern women in pursuit of excellence.',
    content2: 'Every moment with VESCOR skincare is an intimate dialogue with nature and time.<br /><br />As the delicate formula touches your skin, it feels like an Alpine breeze brushing your face.<br />Infused with pure spring water from the Swiss Alps and potent botanical extracts, each formula revives the skin with continuous vitality.<br /><br />VESCOR\'s original 「Gene Anti-Glycation Technology」 precisely targets signs of aging, restoring elasticity and radiance—pausing the footsteps of time.',
    content3: 'In the busyness of modern urban life, VESCOR is more than skincare—it is a lifestyle:<br />Balanced. Composed. Graceful.<br />In every moment of beauty awakening,<br />Unlock the eternal key to being “fearless time”.',
    content4: 'At VESCOR, we believe beauty is the harmonious coexistence of nature and science, the perfect unity of inner and outer well-being. Through the passage of time, one can still steadfastly explore the self and radiate a unique brilliance.<br />Choose VESCOR — dance with time and embody eternal beauty.',
    moreDetails: 'Discover more about the',
    luxuryPlan: 'VESCOR Luxury Skincare Experience Program',
    moreText: 'Details…',
    newGroupTitle1: 'Experience More',
    newGroupTitle2: 'The Secrets of VESCOR...',
    newGroupContent: 'Prevent collagen aging,<br />restore skin elasticity,<br />and revive youthful radiance.',
    rightTitle1: 'Backed by Swiss Scientific Research',
    rightText1: 'Merging cutting-edge science with masterful craftsmanship.',
    rightTitle2: 'Swiss Luxury Skincare Collection',
    rightText2: 'Let your skin “experience the Alps.”'
  },
  tech: {
    // Technology & Expertise section
    techProfessional: {
      title1: 'Technology & Expertise',
      subtitle1: 'Science and Expertise: Swiss Scientific Assurance Opens a New Era in Skincare',
      content1: 'By deeply integrating leading global research and refined craftsmanship—and under the strict guidance of Swissmedic and EU GMP standards—VESCOR ensures a solid foundation of scientific innovation and product safety.',
      subtitle2: 'Dual Commitment to Science and Safety',
      content2: 'Cellcare Laboratory rigorously follows the certification standards set by the Swiss Federal Office of Public Health, ensuring the highest standards across all stages—from R&D to final production.',
      subtitle3: 'Gene Anti-Glycation Complex (Carnosine)',
      subtitle4: 'GENE ANTI-GLYCATION',
      content3: 'Helps prevent collagen glycation in the skin, stimulates collagen production in the dermis, and strengthens dermal structure.<br />Leaves the skin feeling plump and revitalized.<br />With external antioxidant protection and internal anti-glycation defense, it combats aging and sagging, restoring firmness and youthfulness.'
    },
    // Global Top Technology Cooperation section
    globalCooperation: {
      title1: '”Global Technology Partnerships”',
      subtitle1: 'The Source of Innovation and Excellence',
      mibelleTitle: 'Mibelle Group',
      mibelleContent: 'A globally recognized supplier of plant-based actives, Mibelle is known for continuous R&D and cutting-edge skincare innovation. It empowers VESCOR with advanced anti-aging and skin-repair capabilities.',
      crbTitle: 'CRB Laboratory',
      crbContent: 'As a pioneer in eco-certified skincare materials, CRB develops high-performance, safe raw materials using only the best botanicals, ensuring purity and potent efficacy.'
    },
    // Natural Extracts section
    naturalExtract: {
      title1: '“Natural Essences”',
      subtitle1: 'Alpine Spring Water & Organic Botanicals',
      content1: 'Using glacier-fed spring water from Valais, Switzerland, purified and mineral-optimized, VESCOR enhances hydration penetration efficiency by 240% compared to conventional thermal waters.Combined with high-quality organic botanicals cultivated in Europe, this synergy restores vitality and awakens the skin’s youthful brilliance.'
    },
    // Perfect Combination of Research and Craftsmanship section
    researchCraftsmanship: {
      title1: '“The Perfect Fusion of Science and Craftsmanship”',
      subtitle1: 'The fusion of innovation and heritage',
      content1: 'VESCOR’s skincare collection not only emphasizes scientific research and development but also incorporates masterful craftsmanship. We are dedicated to seamlessly blending modern technology with natural ingredients, creating revolutionary skincare innovations.<br /><br />From ingredient selection to formula development, production workflow to texture refinement, every detail reflects respect for science and a passion for aesthetics.'
    },
    // Other Content section
    otherContent: {
      title1: 'Swiss Cellular Anti-Aging Science | Empowering Today’s Elite Skin, Inside and Out',
      subtitle1: 'The Source of Innovation and Excellence',
      content1: 'When urban pollution compromises the skin barrier, when jet lag disrupts cellular recovery, when multiple life roles accelerate collagen loss—VESCOR offers a solution.',
      content2: 'Drawing from 37 years of Cellcare Swiss Laboratory research, VESCOR builds a “3D Bio-Defense Fortress”, forming an intelligent shield for modern women’s skin.',
      subtitle2: 'Certified by Global Quality Standards',
      content3: 'Swissmedic Grade A Production System',
      content4: 'EU EMA Pharmaceutical-Grade GMP Ingredient Selection System'
    },
    // Advanced Biological Delivery System section
    bioDelivery: {
      title1: 'Advanced Bio-Delivery System',
      subtitle1: 'Multi-Layered Targeted Delivery Technology',
      content1: 'Utilizing Mibelle Group’s patented liposome encapsulation, this system delivers Alpine Edelweiss actives with precision. Verified by SGS Switzerland, hydration density in the epidermis improves significantly in 28 days.',
      subtitle2: 'Eco-Barrier Repair System',
      content2: 'CRB’s supercritical CO2 gradient extraction preserves active compounds like calendula flavonoids and madecassoside, clinically shown to accelerate skin repair.'
    },
    // Alpine Matrix section
    alpineMatrix: {
      title1: '"The Alpine Eco Matrix',
      subtitle1: 'Glacier-Activated Water at 2000 Meters',
      content1: 'Using self-rising glacier springs from Valais, Switzerland, processed with nano-magnetic resonance, producing 1.8nm hexagonal water clusters. <br /><br />These increase absorption efficiency by 240% compared to ordinary spring water.',
      title2: 'Organic Botanical Energy Reserve',
      subtitle2: 'Sourced from EU Ecocert-certified farms:',
      content2: '√Mountain roses grown in 18°C daily temperature swings<br /><br />√Edelweiss cultivated under UV index 8+ regions<br /><br />√Centella asiatica selectively bred over 3 generations for medicinal-grade strength'
    },
    // Brand Philosophy section
    brandPhilosophy: {
      title1: 'VESCOR doesn’t just create skincare—it crafts the biological rhythm of your skin.',
      content1: 'Every treatment becomes a graceful resonance of cells and technology. Like Edelweiss in its purity, it awakens the soul alongside the skin.',
      title2: '“True luxury is when time becomes an ally, not an adversary.”',
      content2: '—VESCOR Swiss Aesthetics, dedicated to every woman blooming gracefully in the flow of time.'
    }
  },
  productPage: {
    mainTitle: 'Dear Skincare Explorer,',
    mainContent: 'Are you ready to embark on a transformative journey—one that begins with radiant skin and leads to a renewed sense of self?<br />With VESCOR’s Luxury Skincare Experience Program, unlock the dual rewards of skin renewal and personal empowerment. Dance with time and rediscover the eternal beauty within you.',
    step1Title: 'Step 1: Begin Your VESCOR Experience',
    step1Subtitle: 'Exceptional Care, Visible Results',
    step1Content: 'Choosing VESCOR means stepping into a dedicated skincare ritual that’s as indulgent as it is effective. Spend just 30 minutes a day at home and experience visible transformation from the inside out.<br /><br />Daily Routine: <br/>- Cleanse: Begin with a gentle facial cleanser to thoroughly purify your skin.<br /><br />- Toner: Apply Resilience Revitalizing Essence Water by patting it gently onto your face.<br/><br/>- Serum: Use 2–3 drops of Resilience Revitalizing Anti-wrinkle Serum, smoothing it evenly over your face and neck.<br/><br/>- Cream: Follow with a pea-sized amount of Resilience Revitalizing Anti-wrinkle Cream, massaging until fully absorbed.<br/><br/>- Facial Oil: Seal in moisture with 2–3 drops of Rejuvenating Extract Essence Oil.<br/><br/>- Face Mask (2–3 times a week): Indulge in a Black Diamond Charcoal Facial Mask treatment for 15–20 minutes of pure rejuvenation.<br/><br/>After one month of consistent care, your skin will appear visibly firmer, more radiant, and full of youthful glow. Each application becomes a luxurious promise, each result a chapter in your skin’s renewal story.',
    step2Title: 'Step 2: Share the Glow—Become a Brand Ambassador',
    step2Subtitle: 'From Experience to Influence',
    step2Content: 'Once you’ve experienced the magic of VESCOR, it’s time to inspire others. Share your transformation and let your story empower women around you.<br/><br/>With your passion and influence, you may be selected to become a VESCOR Luxury Beauty Ambassador, gaining access to exclusive benefits, events, and resources.<br/><br/>As a VESCOR Ambassador, you’ll lead a community of radiant, self-assured women toward their own skincare breakthroughs—turning your mirror of confidence into a beacon for many.',
    step3Title: 'Step 3: Co-Create Beauty—Step into a Brighter Future',
    step3Subtitle: 'Grow Together, Shine Brighter',
    step3Content: 'The VESCOR Luxury Skincare Experience is more than just a routine—it’s a movement.<br/><br/>Join a vibrant network of skincare lovers and beauty seekers. Together, we grow, share, and succeed. VESCOR supports you every step of the way with ongoing training, tools, and inspiration.<br/><br/>From glowing skin to personal empowerment, from individual transformation to leading a community—VESCOR invites you to co-create a beautiful new chapter. Let every skincare ritual be a symphony of elegance and energy, inside and out.',
    joinButton: 'Join the VESCOR Luxury Skincare Experience Program today.',
    highlight: 'VESCOR Luxury Skincare Experience Program',
    newSectionTitle: '<span>Experience More</span><br />The Secrets of VESCOR...',
    newSectionContent: 'Prevent collagen aging,<br />Restore skin elasticity<br />Youthful radiance.',
    techPageTitle: 'Swiss Scientific Research Guarantee',
    techPageContent: 'Integrating scientific research strength with craftsmanship.',
    productCatalogTitle: 'Swiss Luxury Product Series',
    productCatalogContent: 'Let your skin "experience the Alps"',
    comingSoon: 'Coming Soon'
  },
  productDetail7: {
    title: 'VESCOR Soft And Moist Liquid Foundation',
    subTitle: 'The Invisible Guardian of Your Skin',
    description: {
      para1: 'In the hustle and bustle of city life, your skin needs a silent protector—an invisible companion that shields against external stressors and provides all-day defense.',
      para2: 'Soft And Moist Liquid Foundation, a Swiss-engineered anti-aging base infused with Camellia Japonica seed oil, becomes that silent shield.',
      para3: 'It creates a naturally radiant, healthy complexion with ease—no cakey texture, no heaviness, just long-lasting beauty that stays with you all day.',
      usageTitle: 'How to Use',
      usageContent: '·Use every morning.<br>·After cleansing and skincare, apply a proper amount to the palm.<br>·Use fingertips or a makeup sponge to evenly blend over the face and neck.<br>·Avoid the eye area. Gently pat to ensure a seamless, natural finish.<br><br>·For longer wear, pair with a light setting powder or setting spray.<br>·Always follow with sunscreen to preserve youthful luminosity.'
    },
    consultationButton: 'China Region (Including Hong Kong, Macau & Mainland) Order Consultation',
    qrCodeInfo: {
      text1: 'You can log in to the <span>VESCOR Official Mini Program</span> by scanning the QR code with WeChat',
      text2: 'Or search and follow the <span>VESCOR Official WeChat Public Account</span>',
      text3: 'for service information and consultation'
    },
    detailItems: [
      {
        subTitle: 'Camellia Japonica Seed Oil',
        subDescription: 'Nature’s Remarkable Power',
        detailList: [
          {
            subTitle: 'Highly Skin-Compatible',
            subDescription: 'Rich in oleic acid—similar to the skin’s natural sebum—for deep hydration and lasting glow.'
          },
          {
            subTitle: 'Antioxidant Defense',
            subDescription: 'Infused with squalene to fight photoaging, reduce wrinkles, and restore youthful vitality.'
          },
          {
            subTitle: 'Brightening Effect',
            subDescription: 'Tea polyphenols inhibit melanin activity to fade discoloration and reveal natural radiance.'
          }
        ]
      },
      {
        subTitle: 'Balanced Inside and Out',
        subDescription: 'Let Your Skin Breathe Freely',
        detailList: [
          {
            subTitle: 'External Protection',
            subDescription: 'Shields against dust, pollution, and oxidation—keeping your skin safe and clean.'
          },
          {
            subTitle: ' Internal Breathability',
            subDescription: 'Lightweight texture prevents pore congestion, allowing your skin to breathe and remain flawless.'
          }
        ]
      },
      {
        subTitle: 'Long-Lasting Coverage',
        subDescription: 'Beauty That Lasts from Day to Night',
        detailList: [
          {
            subTitle: 'Smart Light-Reflecting Technology',
            subDescription: 'High-performance pigments blur imperfections, even out skin tone, and boost luminosity under any lighting.'
          },
          {
            subTitle: ' 24-Hour Wear',
            subDescription: 'Natural oils deliver long-lasting coverage with a gentle, stable formula—perfect from boardroom meetings to evening soirées.'
          }
        ]
      }
    ]
  },
  productDetail6: {
    title: 'VESCOR Rejuvenating Extract Essence Oil',
    subTitle: 'The Key to Locking in Youth',
    description: {
      para1: 'What if your skin had a magical key—one that could lock in youth and block out external damage?',
      para2: 'That key is squalane, the naturally derived core of Rejuvenating Extract Essence Oil.',
      usageTitle: 'How to Use',
      usageContent: '·Apply every morning and evening.<br>·After cleansing and toner, take 2–3 drops into your palm.<br>·Gently massage onto face and neck, avoiding the eye area.<br><br>·Squalane forms a natural protective film on the skin’s surface, locking in moisture and shielding against irritation.<br>·When used in the morning, follow with sun protection to defend skin from external stressors.'
    },
    consultationButton: 'China Region (Including Hong Kong, Macau & Mainland) Order Consultation',
    qrCodeInfo: {
      text1: 'You can log in to the <span>VESCOR Official Mini Program</span> by scanning the QR code with WeChat',
      text2: 'Or search and follow the <span>VESCOR Official WeChat Public Account</span>',
      text3: 'for service information and consultation'
    },
    detailItems: [
      {
        subTitle: 'Squalane',
        subDescription: 'Your Skin’s Natural Shield',
        detailTitle: "A natural lipid barrier, nearly identical to human sebum,",
        detailDescription:
          " squalane creates a breathable film over the skin, locking in hydration and offering protection.Like a wise guardian, it helps your skin resist environmental aggressors, sealing in moisture for long-lasting softness and vitality.",
      },
      {
        subTitle: 'Oil Nourishment',
        subDescription: 'Ageless Skin',
        detailTitle: "Your Second Skin—Not just a slogan, <br/>but a visible result.",
        detailDescription:
          "VESCOR’s facial oil uses a high-performance oil-based formula to deeply nourish the skin.It improves skin elasticity, restores glow, brightens tone, reduces wrinkles, strengthens the moisture barrier, and enhances overall smoothness.",
      }
    ],

    groupLayout: {
      title: 'Swiss-Origin Plant Power – Liquid Gold for Your SkinSourced from Switzerland, each drop delivers intensive care with natural efficacy:',
      items: [
        [
          {
            subTitle: "Brightens the complexion",
            subDescription: "for skin that radiates light and clarity",
          },
          {
            subTitle: "Delivers rapid hydration",
            subDescription: "making skin feel soft, plump, and dewy",
          }
        ],
        [
          {
            subTitle: "Reduces fine lines and wrinkles",
            subDescription: " smoothing away the signs of time",
          },
          {
            subTitle: "Firms facial contours",
            subDescription: "enhancing definition and resilience",
          }
        ],
        [
          {
            subTitle: "Repairs skin barrier",
            subDescription: "rebuilding a strong, healthy defense wall",
          },
          {
            subTitle: "Improves skin texture",
            subDescription: "for silky, touchably smooth skin",
          }
        ]
      ]
    }
  },
  productDetail5: {
    title: 'VESCOR Resilience Revitalizing Anti-wrinkle Cream',
    subTitle: 'The Nutrient Vault',
    description: {
      para1: 'Seal in Bare-Skin Beauty',
      usageTitle: 'How to Use',
      usageContent: '·Use every morning and evening.<br>·After applying toner and serum, dispense a pea-sized amount into the palm.<br>·Gently massage over face and neck until fully absorbed.<br><br>·Locks in anti-aging ingredients while forming a breathable moisture barrier.<br>·For best results, use in combination with VESCOR Resilience Revitalizing series.<br>·Follow with sunscreen in the morning to protect against environmental stressors.'
    },
    consultationButton: 'China Region (Including Hong Kong, Macau & Mainland) Order Consultation',
    qrCodeInfo: {
      text1: 'You can log in to the <span>VESCOR Official Mini Program</span> by scanning the QR code with WeChat',
      text2: 'Or search and follow the <span>VESCOR Official WeChat Public Account</span>',
      text3: 'for service information and consultation'
    },
    detailItems: [
      {
        subTitle: 'Fresh-Lock Barrier',
        subDescription: 'Final Touch of Radiance',
        detailTitle: '',
        detailDescription: 'A lightweight mousse-like texture envelops the skin,sealing in all actives while forming a breathable hydration shield.'
      },
      {
        subTitle: 'Long-Lasting Hydration',
        subDescription: 'Makeup-Enhancing Power',
        detailTitle: '',
        detailDescription: 'Delivers up to 72 hours of moisture retention.Wake up with skin as dewy and plump as a peeled lycheePreps the skin perfectly for makeup, increasing adherence by 200%.'
      }
    ]
  },
  productDetail4: {
    title: 'VESCOR Resilience Revitalizing Anti-wrinkle Serum ',
    subTitle: 'The Dual-Defense Frontline',
    description: {
      para1: 'Reignite Collagen Regeneration',
      para2: 'Deep Penetration, Elastic Activation',
      para3: 'Powered by 5D microcapsule technology, the serum delivers potent antioxidants directly to the dermis, neutralizing free radicals and protecting collagen from breakdown.',
      usageTitle: 'How to Use',
      usageContent: '·Use every morning and evening.<br>·After cleansing, dispense 1–2 pumps into a cotton pad or palm.<br>·Gently pat or massage over face and neck until fully absorbed.<br><br>·Myrtus Communis Leaf Extract strengthens skin’s resilience and delays aging.<br>·Carnosine defends collagen from glycation.<br>·For best results, use in combination with VESCOR Resilience Revitalizing series'
    },
    consultationButton: 'China Region (Including Hong Kong, Macau & Mainland) Order Consultation',
    qrCodeInfo: {
      text1: 'You can log in to the <span>VESCOR Official Mini Program</span> by scanning the QR code with WeChat',
      text2: 'Or search and follow the <span>VESCOR Official WeChat Public Account</span>',
      text3: 'for service information and consultation'
    },
    detailItems: [
      {
        subTitle: 'Antioxidant +',
        subDescription: 'Anti-Glycation Dual Action',
        detailTitle: 'Tocopherol & Ascorbic Acid work together to remove free radicals and stimulate collagen production.',
        detailDescription: 'Raspberry Extract delivers vital minerals to enhance skin vitality.<br/><br/>Myrtus Communis Leaf Extract fortifies the skin’s barrier against aging. <br/>Carnosine supports collagen integrity and boosts skin firmness and elasticity.'
      },
      {
        subTitle: 'Magical Absorption',
        subDescription: '',
        detailTitle: 'Lightweight and non-greasy, this serum is instantly absorbed,leaving your skin breathable, radiant, and comfortable all day long.',
        detailDescription: ''
      }
    ]
  },
  productDetail3: {
    title: 'VESCOR Resilience Revitalizing Essence Water',
    subTitle: 'Your First Step in Antioxidant Defense',
    description: {
      para1: 'Launch Your Anti-Glycation Mission',
      usageTitle: 'How to Use',
      usageContent: '·Use every morning and evening.<br>·After cleansing, dispense 3–4 pumps into a cotton pad or palm.<br>·Gently pat or swipe over face and neck until fully absorbed.<br><br>·Contains Carnosine (Gene Anti-Glycation Complex) to prevent collagen glycation.<br>·Mildly acidic pH helps soften the stratum corneum and enhances absorption for follow-up care.<br>·For best results, use in combination with VESCOR Resilience Revitalizing series.'
    },
    consultationButton: 'China Region (Including Hong Kong, Macau & Mainland) Order Consultation',
    qrCodeInfo: {
      text1: 'You can log in to the <span>VESCOR Official Mini Program</span> by scanning the QR code with WeChat',
      text2: 'Or search and follow the <span>VESCOR Official WeChat Public Account</span>',
      text3: 'for service information and consultation'
    },
    detailItems: [
      {
        subTitle: 'Purifying Primer',
        subDescription: 'A Balanced Base',
        detailTitle: 'A mildly acidic formula that gently softens dead skin cells,opening the way for deeper skincare penetration.',
        detailDescription: ''
      },
      {
        subTitle: 'Dual Antioxidant ',
        subDescription: 'Anti-Glycation Complex',
        detailTitle: 'Tocopherol and Ascorbic Acid work in synergy',
        detailDescription: 'Tocopherol (Vitamin E) and Ascorbic Acid (Vitamin C) work synergistically to eliminate free radicals and boost collagen synthesis, resulting in firmer, more resilient skin.<br/><br/>Raspberry Extract, rich in trace elements, enhances cellular metabolism and revitalizes the complexion.<br/><br/>Myrtus Communis Leaf Extract boosts skin’s natural defense, delays aging, and rejuvenates.Carnosine protects collagen from glycation, reinforcing dermal structure and restoring plumpness.'
      },
      {
        subTitle: 'Magical Activation',
        subDescription: '',
        detailTitle: 'With just a 3-second pat, awaken your skin’s absorption powerand lay the foundation for deeper serum infusion.',
        detailDescription: ''
      }
    ]
  },
  productDetail2: {
    title: 'BLACK DIAMOND CHARCOAL FACIAL MASK',
    subTitle: 'Reveal the Secret to Skin Renewal',
    description: {
      para1: 'Powered by the magical properties of Binchotan charcoal, this mask is your key to radiant, purified skin.',
      para2: 'Its ultra-porous structure acts like a magnet—drawing out deep impurities and excess oil with every use.Each mask session offers a complete skin reset, leaving your complexion clean, refreshed, and awakened.',
      usageTitle: 'How to Use',
      usageContent: '·Use 2–3 times per week.<br>·After cleansing, apply the sheet mask to the face, avoiding eye and lip areas.<br>· Leave on for 15–20 minutes.<br><br>·Remove and gently massage the remaining serum until fully absorbed.<br>·For optimal results, use with the VESCOR Resilience Revitalizing Series. '
    },
    consultationButton: 'China Region (Including Hong Kong, Macau & Mainland) Order Consultation',
    qrCodeInfo: {
      text1: 'You can log in to the <span>VESCOR Official Mini Program</span> by scanning the QR code with WeChat',
      text2: 'Or search and follow the <span>VESCOR Official WeChat Public Account</span>',
      text3: 'for service information and consultation'
    },
    detailItems: [
      {
        subTitle: 'Hydration Surge',
        subDescription: 'Deep Nourishment',
        detailTitle: 'Thirsty skin? This mask delivers ultra-hydrating care.',
        detailDescription: 'Infused with hyaluronic acid, it saturates the skin with moisture,leaving it plump, smooth, and glowing.<br/><br/>Collagen enhances elasticity, lifts facial contours, and rebuilds firmness.<br/><br/>It also strengthens the skin barrier, boosting resilience and overall health.'
      },
      {
        subTitle: 'Soothing Star Ingredients',
        subDescription: ' Skin’s Gentle Guardian',
        detailTitle: '',
        detailDescription: 'Featuring Centella Asiatica, Japanese knotweed root, skullcap root, and rosemary leaf extract, this mask calms, heals, and protects your skin throughout the purification process.'
      },
      {
        subTitle: 'High-Activity Peptide Complex',
        subDescription: 'Your Anti-Aging Arsenal',
        detailTitle: 'As we age, skin’s repair ability diminishes.',
        detailDescription: 'The multi-peptide complex in this mask stimulates cell renewal and collagen production, restoring youthful vitality and luminosity while fading dullness and fatigue.'
      }
    ]
  },
  productDetail1: {
    title: 'VESCOR COLLAGEN SECRET SKIN MASK',
    subTitle: 'A Sweet Swiss Getaway for Your Skin',
    description: {
      para1: 'Your skin whispers, “I need a vacation… to Switzerland.”',
      para2: 'When your skin longs for a break, the VESCOR Collagen Honey Glow Mask is its first-class ticket.In just 20 minutes, enjoy a luxurious spa experience that leaves skin saying:“I’ve returned—more radiant, more youthful.”',
      para3: 'A 20-Minute Swiss Escape for Renewed Radiance',
      para4: 'Each application is an immersive spa ritual. Each drop of essence—a gift from nature. Each minute—a transformative moment for your skin. In just 20 minutes, it’s not just time passing—it’s your skin’s elegant rebirth. With VESCOR, every moment of care becomes a feast of rejuvenation, a youthful awakening.',
      usageTitle: 'How to Use',
      usageContent: '·Use 2–3 times per week.<br>·After cleansing, apply the sheet mask over the face, avoiding eye and lip areas.<br>·Leave on for 15–20 minutes.<br><br>·Remove and gently massage the remaining serum until fully absorbed.<br>·For best results, pair with the VESCOR Resilience Revitalizing Series.'
    },
    consultationButton: 'China Region (Including Hong Kong, Macau & Mainland) Order Consultation',
    qrCodeInfo: {
      text1: 'You can log in to the <span>VESCOR Official Mini Program</span> by scanning the QR code with WeChat',
      text2: 'Or search and follow the <span>VESCOR Official WeChat Public Account</span>',
      text3: 'for service information and consultation'
    },
    detailItems: [
      [
        {
          subTitle: 'Collagen',
          subDescription: 'The Fountain of Youth',
          detailTitle: 'Rich in collagen, this mask is your secret to youthful skin.',
          detailDescription: 'Penetrating deep into the dermis, it reactivates cell vitality, restoring bounce and an 18-year-old glow.<br/><br/>It hydrates, firms, and refines facial contours while strengthening the skin barrier for healthier, more resilient skin.'
        },
        {
          subTitle: 'Hydration Power',
          subDescription: 'A Waterfall for Your Skin',
          detailTitle: '',
          detailDescription: 'Infused with refreshing Swiss spring water, the mask drenches your skin in moisture. Hyaluronic acid delivers intense hydration, smoothing the skin like a freshly peeled egg. It locks in moisture for 24-hour dewiness.<br/><br/>Swiss glacier water, rich in minerals and trace elements, deeply nourishes and revives skin from within.'
        },
        {
          subTitle: 'Botanical Extracts',
          subDescription: 'A Gentle Retreat',
          detailTitle: 'Centella Asiatica and Echinacea soothe and calm the skin.',
          detailDescription: 'These botanical extracts provide natural anti-inflammatory relief, making the mask ideal for sensitive skin.<br/><br/>Centella is known as a “natural healer,” promoting collagen synthesis and restoring damaged skin cells.'
        }
      ],
      [
        {
          subTitle: '360° Fit',
          subDescription: 'Seamless Skin Contact',
          detailTitle: '',
          detailDescription: 'Engineered to conform perfectly to your facial contours. Using ultra-thin fiber technology—just 1/3 the thickness of conventional masks—the sheet feels virtually weightless.<br/><br/>It adheres like a second skin, forming a breathable seal that enhances serum absorption and comfort.'
        },
        {
          subTitle: 'Natural Fragrance',
          subDescription: 'An Immersive Swiss Journey',
          detailTitle: '',
          detailDescription: 'From the moment you open the mask, you’re transported to the Swiss Alps.The scent blends Swiss pine, Alpine meadow florals, and a hint of refreshing mint, inviting you into 20 minutes of serene, sensory escape.'
        }
      ]
    ]
  },
  cooperation: {
    mainTitle: 'Quality: Your Ticket Through Time<br />At VESCOR, we approach skincare with reverence—crafting each product to meet the expectations of discerning skin.',
    paragraphs: {
      txt1: 'From the pristine raw materials of the Swiss Alps to cutting-edge laboratories, nature and technology converge in every bottle. This is more than a skincare revolution—it’s a philosophy of renewal.',
      txt2: 'Science: The Magic You Can See<br />We decode the traces of time etched on the skin, transforming complex molecular formulas into visible change. Advanced technologies reawaken dormant cells, turning anxiety over fine lines, dullness, and sagging into awe-inspiring results.',
      txt3: 'Brand: A Silent Promise<br />The glow in a display window reflects the trust of countless customers. We don’t just build shelves—we build bridges to a premium lifestyle. Every partnership is a beacon of the high-end skincare experience.',
      txt4: 'Co-Prosperity: The Only Answer<br />The growth curve of our partners is the lifeline of our brand. From logistics to end-user service, from visual design to user experience, VESCOR fosters a mutually thriving ecosystem.',
      txt5: 'Now, we extend an invitation to the world—choose VESCOR, align with cutting-edge science, and lead the high-end skincare wave.Empowered by Beauty. Unafraid of Time. Let’s write the future of beauty, together.'
    },
    consultationSection: {
      title: 'China Region (Hong Kong, Macau & Mainland) Cooperation Details Consultation',
      subtitle: 'China (Hong Kong, Macau & Mainland China) cooperation details c',
      comingSoon: 'Coming Soon'
    }
  },
  contact: {
    mainTitle: 'VESCOR. Asia Business Partnership',
    subTitle: 'SWISS VESCOR HEALTH MEDICAL TREATMENT (HONG KONG) TECH CO., LIMITED',
    businessCenter: 'Asia Business Management Center',
    hongkongAddress: '<span>Hong Kong Office</span> <br /><br />Room 63, 7/F, Woon Lee Commercial Building<br />7-9 Austin Avenue, Tsim Sha Tsui,<br />Hong Kong, China',
    email: 'vescorchina@vescorskincar.com',
    comingSoon: 'Coming Soon',
    consultationItems: [
      {
        title: 'China Region (Hong Kong, Macau & Mainland) Cooperation Details Consultation',
        subtitle: 'China (Hong Kong, Macau & Mainland China) cooperation details consultation'
      },
      {
        title: 'Asia Cooperation Details Consultation',
        subtitle: 'Asia cooperation details consultation'
      },
      {
        title: 'North America Cooperation Details Consultation',
        subtitle: 'Marketing and sales cooperation'
      }
    ]
  },
  productCatalog: {
    title: 'Swiss Luxury Skincare Collection',
    subtitle: 'Let your skin “Experience the Alps”',
    allProducts: 'All products',
    masks: 'Mask Series',
    elasticSeries: 'Resilience Revitalizing Series',
    essenceSeries: 'Regenerating Botanical Series',
    checkDetails: 'View Details',
    products: {
      softMoistFoundation: {
        name: 'Soft And Moist Liquid Foundation',
        desc: 'Camellia Seed Oil Extract<br/>the magical power of nature,the invisible guardian of your skin.'
      },
      collagenMask: {
        name: 'COLLAGEN SECRET SKIN MASK',
        desc: 'A Swiss sweet escape for your skin<br/>a 20-minute journey to Switzerland that leaves your skin refreshed and renewed.'
      },
      blackDiamondMask: {
        name: 'BLACK DIAMOND CHARCOAL FACIAL MASK',
        desc: 'The magical power of Binchotan Charcoal<br/>Black Diamond energy to awaken your sleeping beauty skin.'
      },
      resilienceWater: {
        name: 'Resilience Revitalizing Essence Water',
        desc: 'Launch Your Anti-Glycation Mission'
      },
      resilienceSerum: {
        name: 'Resilience Revitalizing Essence Serum',
        desc: 'Deep penetration, elasticity activation<br/>Dual benefits of anti-oxidation and anti-glycation.'
      },
      resilienceCream: {
        name: 'Resilience Revitalizing Essence Cream',
        desc: 'Lock in a naturally flawless look<br/>Fresh protection with long-lasting hydration.'
      },
      rejuvenatingOil: {
        name: 'Rejuvenating Extract Essence Oil',
        desc: 'Skin’s natural “protective shield”<br/>SqualaneDefends against external aggressors and locks in youth.'
      }
    }
  },
}